/*global chrome*/
import React, { Component } from "react";

import supportHeroImg from "../../../../../images/support-hero-img.png";
import playIcon from "../../../../../images/modal-icons/play-btn.png";
import avatar from "../../../../../images/avatar.png";
import supportPlaceholder from "../../../../../images/support-img.jpg";
import supportPlaceholder2 from "../../../../../images/support-img-2.jpg";
import navIcon from "../../../../../images/nav-icon.svg";
import arrowIcon from "../../../../../images/arrow-qst.png";
import slackIcon from "../../../../../images/slack.svg";
import OwlCarousel from "react-owl-carousel";

import extensionDoc from "./docs/Super-Chrome-Extension-Manual.docx";
import installationDoc from "./docs/Supervity-Software-requirements-and-dependencies-installation-steps.docx";
import guideDoc from "./docs/Supervity-Guidelines.docx";

import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";
import { notify } from "../../../../../redux/actions/snackActions";
import { executeFlow, getSession } from "../../../../../redux/actions/skill";
import { Store } from "react-notifications-component";

let videos = [
  {
    title: "Supervity - QuickStart Introduction",
    link: "https://youtu.be/xtCko0rqw_8",
    img: "https://img.youtube.com/vi/xtCko0rqw_8/hqdefault.jpg",
  },
  {
    title: "Supervity - Prerequisities for web walkthroughs/automations",
    link: "https://youtu.be/nQh8j_B_wTs",
    img: "https://img.youtube.com/vi/nQh8j_B_wTs/hqdefault.jpg",
  },
  {
    title: "Supervity - Prerequisities for Desktop walkthroughs/automations",
    link: "https://youtu.be/1xBlA_D8Mnw",
    img: "https://img.youtube.com/vi/1xBlA_D8Mnw/hqdefault.jpg",
  },
  {
    title: "Supervity - Walkthrough Creation",
    link: "https://youtu.be/S_RNVuCDIRc",
    img: "https://img.youtube.com/vi/S_RNVuCDIRc/hqdefault.jpg",
  },
  {
    title: "Supervity - Update tooltip messages/images in walkthroughs",
    link: "https://youtu.be/DpMd3SdaX6k",
    img: "https://img.youtube.com/vi/DpMd3SdaX6k/hqdefault.jpg",
  },
  {
    title: "Supervity - Mask sensitive data in walkthroughs",
    link: "https://youtu.be/7ui4Stt3c1k",
    img: "https://img.youtube.com/vi/7ui4Stt3c1k/hqdefault.jpg",
  },
  {
    title: "Supervity - Browser Widget to search for App related Walkthroughs",
    link: "https://youtu.be/oDpy755zkZQ",
    img: "https://img.youtube.com/vi/oDpy755zkZQ/sddefault.jpg",
  },
  {
    title: "Supervity - MyKnowledge",
    link: "https://youtu.be/-0AlZZ4nn0g",
    img: "https://img.youtube.com/vi/-0AlZZ4nn0g/sddefault.jpg",
  }
];

let walkthroughs = [
  {
    id: 4649,
    title1: "How to install dependencies for",
    title2: "Supervity desktop",
    description:
      "This skill shows the steps to be followed to install dependencies for Supervity desktop",
    img: supportPlaceholder,
    skillName: "How to install dependencies for Supervity desktop",
  },
  {
    id: 4650,
    title1: "How to install dependencies for",
    title2: "Supervity web",
    description:
      "This skill shows the steps to be followed to install dependencies for Supervity web",
    img: supportPlaceholder2,
    skillName: "How to install dependencies for Supervity web",
  },
  // {
  //   id: 1939,
  //   title1: "Super profile section",
  //   title2: "walkthrough",
  //   description:
  //     "This skill shows the steps to be followed to install dependencies for Supervity desktop",
  //   img: supportPlaceholder,
  //   skillName: "Super profile section walkthrough",
  // },
  {
    id: 5226,
    title1: "Introduction to",
    title2: "teams concept",
    description: "Introduction tour on teams concept",
    img: supportPlaceholder,
    skillName: "Introduction to teams concept",
  },
];
let articles = [
  {
    title1: "Super chrome",
    title2: "extension manual",
    description:
      "The Super chrome extension is an integral part of Supervity, to give a brief the extension has the backend logic required to record the various show actions performed on Supervity. It also has a skill triggering mechanism on the user interface which can be used to trigger the various skills available.",
    link: "/dashboard/skills/extensionManual",
  },
  {
    title1: "Supervity Software requirements and dependencies installation",
    title2: "",
    description:
      "There are 2 types of dependencies for Supervity. The browser plug-in which is used for the web-based automations wherein we support chrome and edge browsers and the desktop app which is used for the desktop-based automations wherein we support the windows operating system.",
    link: "/dashboard/skills/requirements",
  },
  {
    title1: "Supervity",
    title2: "Guidelines",
    description:
      "The following guidelines will give you best leverage of Supervity application. 1. Use Desktops/Laptops/Virtual Machines (VMs) with the below minimal configuration for better experience with Supervity.",
    link: "/dashboard/skills/guidelines",
  },
];

class Support extends Component {
  constructor() {
    super();
    this.state = {
      videos,
      walkthroughs,
      articles,
      skills: [],
      isLoading: true,
      currentCategory: "",
      allSkills: [],
      options: {
        // loop: true,
        margin: 15,
        nav: true,
        navText: [
          `<div class='sk-slide-nav owl-prev'><img src=${navIcon} /></div>`,
          `<div class='sk-slide-nav owl-next'><img src=${navIcon} /></div>`,
        ],
        dots: false,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 3,
          },
          1000: {
            items: 4,
          },
        },
      },
    };
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange = (e) => {
    var searchInput = document.getElementById("searchInput").value;

    const videoResults = videos.filter((video) => {
      if (searchInput === "") return videos;
      return video.title.toLowerCase().includes(searchInput.toLowerCase());
    });
    const walthroughResults = walkthroughs.filter((walkthrough) => {
      if (searchInput === "") return walkthroughs;
      return (
        walkthrough.title1.toLowerCase().includes(searchInput.toLowerCase()) ||
        walkthrough.title2.toLowerCase().includes(searchInput.toLowerCase())
      );
    });
    const articlesResults = articles.filter((article) => {
      if (searchInput === "") return articles;
      return (
        article.title1.toLowerCase().includes(searchInput.toLowerCase()) ||
        article.title2.toLowerCase().includes(searchInput.toLowerCase())
      );
    });
    this.setState({
      ...this.state,
      videos: videoResults,
      walkthroughs: walthroughResults,
      articles: articlesResults,
    });
  };

  executeWalkthrough = async (skill) => {
    let _device = await this.props.getSession();
    var data = {
      deviceId: _device,
      skillId: skill,
    };

    const playSkill = await this.props.executeFlow(data);
  };
  checkChromeExtension = (skillId) => {
    try {
      chrome.runtime.sendMessage(
        process.env.REACT_APP_CHROME_TAB_ID,
        { type: "ping" },
        (response) => {
          if (!response) {
            this.notificationPopUp();
          } else {
            this.executeWalkthrough(skillId);
          }
        }
      );
    } catch (error) {
      this.notificationPopUp();
      console.log("error ", error);
    }
  };

  notificationPopUp() {
    Store.addNotification({
      title: "Note: ",
      message:
        "Ohh! Seems you don't have Super browser extension added to your browser. Please add it before creating/using skills.",
      type: "warning",
      insert: "top",
      container: "top-right",
      dismiss: {
        duration: 5000,
        onScreen: true,
      },
    });
    window.setTimeout(function () {
      window.open(
        `https://chrome.google.com/webstore/detail/techforce-ide-extension/${process.env.REACT_APP_CHROME_TAB_ID}`,
        "_blank"
      );
    }, 5000);
  }
  render() {
    return (
      <div className="skill-home scrollable">
        {/* <div className="tp-title flex-title">
                    <h3>Support</h3>
                </div> */}
        <div className="spt-hero">
          <div className="row">
            <div className="col-md-6">
              <div className="spt-hero-content">
                <h1>Help Center</h1>
                <p>How can we help you Today?</p>
                <div className="spt-search">
                  <input id="searchInput" placeholder="Please enter your search..." type="text"></input>
                  <input
                    type="submit"
                    value="Search"                    
                    onClick={this.handleChange}
                  ></input>
                </div>
                <div className="slack-box">
                  <a
                    href="https://discord.com/invite/KcyYmCEc4J"
                    target="_blank"
                    className="btn btn-outline btn-slack"
                  >
                    Join Support Group
                  </a>
                  <a
                    href="https://www.supervity.ai/help-and-support/"
                    target="_blank"
                    className="btn btn-primary btn-slack"
                  >
                    New to Supervity? Start Here
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="spt-hero-img">
                <img src={supportHeroImg} />
              </div>
            </div>
          </div>
        </div>
        <div className="spt-section spt-videos">
          <div className="spt-title-center">
            <h3 className="spt-title">Videos</h3>
          </div>
          <OwlCarousel className="owl-theme" {...this.state.options}>
            {this.state.videos.map((video, index) => {
              return (
                <div class="item">
                  <div className="spt-slide-item">
                    <a href={video.link} target="_blank">
                      <div className="spt-item-thumbnail">
                        <div className="spt-video-item">
                          <img src={playIcon} />
                        </div>
                        <img src={video.img} />
                      </div>
                    </a>
                    <div className="spt-item-text">
                      <p title={video.title}>{video.title}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </OwlCarousel>
        </div>
        <div className="spt-section spt-items">
          <div className="spt-title-center">
            <h3 className="spt-title">Walkthroughs</h3>
          </div>
          <OwlCarousel className="owl-theme" {...this.state.options}>
            {this.state.walkthroughs.map((walkthrough, index) => {
              return (
                <div class="item">
                  <div className="spt-slide-item">
                    <div className="spt-item-thumbnail">
                      <img src={walkthrough.img} />
                    </div>
                    <div className="spt-item-text">
                      <p data-super-skill={walkthrough.skillName}>
                        {walkthrough.title1}
                        <br /> {walkthrough.title2}
                      </p>
                      <span
                        data-super-skill={walkthrough.skillName}
                        className="spt-sm-text"
                      >
                        {walkthrough.description}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </OwlCarousel>
        </div>

        <div className="spt-section spt-articles">
          <div className="spt-title-center">
            <h3 className="spt-title">Top Help Articles</h3>
          </div>
          <div className="row">
            {this.state.articles.map((article, index) => {
              return (
                <div className="col-md-4">
                  <div className="spt-article-block" onClick={() => {
                        window.location.href = article.link;
                      }}>
                    <h3>
                      {article.title1}
                      <br /> {article.title2}
                    </h3>
                    <p>{article.description}</p>
                    <a
                      className="btn btn-primary"
                      onClick={() => {
                        window.location.href = article.link;
                      }}
                      download
                    >
                      <span>Read More</span>
                      <img src={arrowIcon} />
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  skills: state.skillReducer,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    executeFlow,
    getSession,
  })
)(Support);
